import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ServiceRegister = React.lazy(() =>
    import('../ServiceRegister')
);
const serviceRegisterRoutes = [
    {
        path: PAGE_URL.SERVICE_REGISTER_PAGE,
        element: <ServiceRegister />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default serviceRegisterRoutes;
